module.exports = __webpack_public_path__ + "media/images/lb/176-bce5b0e8c14c0fae0741a0fa19392b20.svg";